import { render } from "./header.vue?vue&type=template&id=b36a8704"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=b36a8704&lang=scss&rel=stylesheet%2Fscss"
script.render = render

export default script